import type { User } from "src/types/user";
import { rankingRoutes } from "src/views/ranking/routes";

const DISABLE_RANKING_PAGE_ACCESS_USER_ID_LIST = "VITE_DISABLE_RANKING_PAGE_ACCESS_USER_ID_LIST";

const PAGE_NEED_A_CHECK = [
    {
        path: rankingRoutes.root(),
        refusedIdList: import.meta.env[DISABLE_RANKING_PAGE_ACCESS_USER_ID_LIST],
    },
];

export const isPageAllowed = ({ path, user }: { path: string; user: User }): boolean => {
    const userId = user.id;

    const page = PAGE_NEED_A_CHECK.find((page) => page.path === path);
    if (!page) {
        return true;
    }

    const userIdList = page.refusedIdList?.split(";") ?? [];
    return !userIdList.includes(userId.toString());
};
